import { render } from "./PageHeader.vue?vue&type=template&id=b98564b8&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=b98564b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98564b8"]])

export default __exports__